var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnchor = function SvgAnchor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.059 1.988a2.48 2.48 0 0 1 .6 4.888v3.583h2.223a.6.6 0 0 1 0 1.2h-2.224v8.185a7.87 7.87 0 0 0 4.966-2.28 7.87 7.87 0 0 0 2.238-4.561l-.947.474a.6.6 0 0 1-.537-1.074l1.883-.941a.602.602 0 0 1 .868.537 9.068 9.068 0 0 1-8.47 9.048v.364a.6.6 0 0 1-1.2 0v-.364a9.07 9.07 0 0 1-8.47-9.048.6.6 0 0 1 .867-.537l1.882.941a.6.6 0 1 1-.536 1.073l-.948-.473a7.87 7.87 0 0 0 2.24 4.561 7.87 7.87 0 0 0 4.965 2.28v-8.186H9.234a.6.6 0 0 1 0-1.199h2.225V6.876a2.48 2.48 0 0 1 .6-4.888m0 1.2a1.284 1.284 0 0 0 0 2.565 1.283 1.283 0 0 0 0-2.565"
  })));
};
export default SvgAnchor;